import Icon from "Components/Icon";
import { useNetStatus } from "Contexts/NetStatusContext";
import { useTranslation } from "react-i18next";
import { ToastErrorBottomLeft, ToastSuccessBottomLeft } from "Utils/toastService";

const NetStatus = () => {
    const [t] = useTranslation()
    const { netStatus, setNetStatus } = useNetStatus();

    const clickHandle = () => {
        if (netStatus == "MANUAL_OFF") {
            setNetStatus("ON")
            ToastSuccessBottomLeft(t("NET_IS_ON"))
        }
        else {
            setNetStatus("MANUAL_OFF")
            ToastErrorBottomLeft(t("NET_IS_OFF"))
        }
    }

    return (
        <div className="relative" onClick={clickHandle}>
            <Icon name={netStatus == "ON" ? "wifi" : (netStatus == "OFF" ? "wifi-1" : "wifi-off")} className="w-6 h-6 text-gray-600" />
            <span className={`w-[10px] h-[10px] rounded-full absolute left-0 top-0 ${netStatus == "ON" ? "bg-success" : (netStatus == "OFF" ? "bg-warning" : "bg-error")}`} />
        </div>)
}

export default NetStatus;
